<template>
  <div class="row justify-center q-gutter-xs multi-options-animated-button">
    <div v-for="(option, index) in options" :key="index"
         :class="buttonClasses(option, index)"
         class="column no-wrap items-center justify-between image-button"
         v-touch:start="onPressStart(index)"
         v-touch:end="onPressEnd"
         @click="option.action(option)">
      <lottie-player :src="option.animation" autoplay loop style="height: 71px" class="animation" />
      <div v-if="option.label"
           class='r-text-regular label'
           :class="labelClasses(option, index)">
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiOptionsImageButton',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      pressedIndex: null,
    };
  },
  methods: {
    isSelected(index) {
      return index === this.pressedIndex;
    },
    onPressStart(index) {
      return () => {
        this.pressedIndex = index;
      };
    },
    onPressEnd() {
      this.pressedIndex = null;
    },
    labelClasses(option, index) {
      if (this.isSelected(index)) {
        return ['r-text-bold', 'text-riseup-blue'];
      }
      return [`text-${option.textColor}`];
    },
    buttonClasses(option, index) {
      const classes = [`bg-${option.color}`];
      if (this.isSelected(index)) {
        classes.push('pressed');
      }
      return classes;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/styles/riseup.brand";

.multi-options-animated-button {
  padding: 6px;

  .image-button {
    cursor: pointer;
    flex: 1 1 0;
    border-radius: 3px;

    .animation {
      padding-top: 2px;
    }

    .label {
      padding-bottom: 5px;
    }

    &.pressed {
      background-color: $riseup-light_blue;
    }
  }
}

</style>
